import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GroupBatchCreator from './BatchGroupViewer';
import { Loading } from '../../../Other/Loading';

const InstructorCreateBatch = () => {
  const user = useSelector((state) => state.users.user);
  const instructorId = user?.userId || user?.id;
  const navigate = useNavigate();

  if (!user) {
    return <Loading />;
  }

  return (
    <div className="mx-auto p-6 bg-white">
      <GroupBatchCreator
        instructorId={instructorId}
        onClose={() => navigate('/dashboard')}
      />
    </div>
  );
};

export default InstructorCreateBatch;
